import React from 'react';

export const DumpsterIcon = (props) => {
  return (
    <svg viewBox='0 0 576 512' fill='currentColor' height='1em' width='1em' {...props}>
      <path d='M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94l25.6-128H49.7zM272 160V32h-98.9l-25.6 128H272zm32 0h124.5L402.9 32H304v128zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9 0-2.1-.3-4.1-.9-6.1l-25.9-84.1c-3.1-10-12.4-16.9-22.9-16.9h-90.8l25.6 128zM32 192l4 32h-4c-17.7 0-32 14.3-32 32s14.3 32 32 32h12l20 160c0 17.7 14.3 32 32 32s32-14.3 32-32h320c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z' />
    </svg>
  );
};
